export const MOVEMENT_DOCUMENT_MANDATORY = {
  YES: 'YES',
  NO: 'NO',
  CONDITIONAL: 'CONDITIONAL',
};

export function normalizeMovementDocumentMandatory(value) {
  if (value === true || String(value).toUpperCase() === 'TRUE') {
    return MOVEMENT_DOCUMENT_MANDATORY.YES;
  }

  if (value === false || String(value).toUpperCase() === 'FALSE') {
    return MOVEMENT_DOCUMENT_MANDATORY.NO;
  }

  const normalizedValue = String(value).toUpperCase();

  if (Object.values(MOVEMENT_DOCUMENT_MANDATORY).includes(normalizedValue)) {
    return normalizedValue;
  }

  return MOVEMENT_DOCUMENT_MANDATORY.NO;
}

export function formatMovementDocumentMandatory(value) {
  const labels = {
    [MOVEMENT_DOCUMENT_MANDATORY.YES]: 'Sim',
    [MOVEMENT_DOCUMENT_MANDATORY.NO]: 'Não',
    [MOVEMENT_DOCUMENT_MANDATORY.CONDITIONAL]: 'Condicional',
  };

  return labels[normalizeMovementDocumentMandatory(value)];
}
